module.exports = require("core-js/stable");